var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ls-flex scope-set-min-height scoped-general-settings",
      class: _vm.collapsedMenu ? "collapsed" : "non-collapsed",
      on: { dblclick: _vm.toggleEditMode }
    },
    [
      _c("transition", { attrs: { name: "slide-fade" } }, [
        !_vm.loading && !_vm.collapsedMenu
          ? _c(
              "div",
              {
                staticClass:
                  "panel panel-default question-option-general-container col-12",
                attrs: { id: "uncollapsed-general-settings" }
              },
              [
                _c("div", { staticClass: "panel-heading" }, [
                  _vm._v(
                    " \n                " +
                      _vm._s(_vm._f("translate")("General Settings")) +
                      "\n                "
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "pull-right btn btn-default btn-xs",
                      on: {
                        click: function($event) {
                          _vm.collapsedMenu = true
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-chevron-right" })]
                  )
                ]),
                _c("div", { staticClass: "panel-body" }, [
                  _c(
                    "div",
                    { staticClass: "list-group" },
                    _vm._l(_vm.generalSettingOptions, function(generalSetting) {
                      return _c(
                        "div",
                        {
                          key: generalSetting.name,
                          staticClass:
                            "list-group-item question-option-general-setting-block"
                        },
                        [
                          _c(_vm.getComponentName(generalSetting.inputtype), {
                            tag: "component",
                            attrs: {
                              elId: generalSetting.formElementId,
                              elName: generalSetting.formElementName,
                              elLabel: generalSetting.title,
                              elHelp: generalSetting.formElementHelp,
                              currentValue: generalSetting.formElementValue,
                              elOptions: generalSetting.formElementOptions,
                              debug: generalSetting,
                              readonly: _vm.isReadonly(generalSetting)
                            },
                            on: {
                              change: function($event) {
                                return _vm.reactOnChange($event, generalSetting)
                              }
                            }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  )
                ])
              ]
            )
          : _vm._e()
      ]),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        !_vm.loading && _vm.collapsedMenu
          ? _c(
              "button",
              {
                staticClass: "btn btn-default scoped--special-collapse",
                attrs: { id: "collapsed-general-settings" },
                on: {
                  click: function($event) {
                    _vm.collapsedMenu = false
                  }
                }
              },
              [
                _c("i", { staticClass: "fa fa-chevron-left" }),
                _c("div", { staticClass: "special-collapse-text" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm._f("translate")("General Settings")) +
                      "\n            "
                  )
                ])
              ]
            )
          : _vm._e()
      ]),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.loading
          ? _c(
              "div",
              { staticClass: "row" },
              [_c("loader-widget", { attrs: { id: "generalSettingsLoader" } })],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }